export enum PlanUpgradeRequestStatus {
    UnderReview = 'UnderReview',
    Approved = 'Approved',
    Rejected = 'Rejected'
}